import React from 'react'
import { useParams } from 'react-router-dom'

import { ContractForm } from './ContractForm'

export const CreateContract: React.FC = () => {
  const { personUuid } = useParams<{ [key: string]: string }>()

  return <ContractForm type={'create'} personUuid={personUuid} />
}
